/* Hide "Save for later" on Essential cart drawer product lines */
(function () {
  'use strict';
  let timer;

  const apply = async () => {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());

      const giftVariantIds = new Set(
        cart.items
          .filter((i) => i.properties && i.properties.__essential_cart_drawer_reward_tier_id)
          .map((i) => String(i.variant_id))
      );

      document
        .querySelectorAll('[data-essential-cart-element="cart-drawer-item"] .favo-sfl-btn')
        .forEach((btn) => {
          const wrapper = btn.closest('.favo-sfl-btn-wrapper') || btn;
          const id = btn.dataset.wlVariantId;
          if (id && giftVariantIds.has(id)) {
            wrapper.classList.remove('sfl-ok');
          } else {
            wrapper.classList.add('sfl-ok');
          }
        });
    } catch (e) { /* silent */ }
  };

  const schedule = () => { clearTimeout(timer); timer = setTimeout(apply, 150); };

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('cart:update', schedule);
  schedule();
})();